<div class="container">
    <div class="row justify-content-center">
        <div class="box col-12 col-xl-9">
            <div class="box__cont">
                <div class="box__title">
                    <h1>CREATE YOUR ACCOUNT</h1>
                    <h2>to access Partners Portal</h2>
                    <h3 class="box__error-notif" *ngIf="isNotValidInputs">All fields are required to be answered. Please try again.</h3>
                </div>
                <div class="box__form">
                    <div class="row">
                        <div class="col-12 col-sm-6 box__field">
                            <span class="box__span">Company Email</span>
                            <p class="box__text-fixed" style="word-break: break-word">{{searchFormGroup.get('companyEmail')?.value}}</p>
                        </div>
                        <div class="col-12 col-sm-6 box__field">
                            <span class="box__span">Company Code</span>
                            <p class="box__text-fixed">{{searchFormGroup.get('companyCode')?.value}}</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-sm-6 box__field">
                            <atram-textbox [parentFormGroup]="searchFormGroup"
                                            type="text"
                                            controlName="firstName"
                                            label="First Name"
                                            placeholder="First Name"
                                            [isError]="!searchFormGroup.get('firstName')?.valid && searchFormGroup.get('firstName')?.touched"
                                            [isRequired]="true">
                            </atram-textbox>
                        </div>
                        <div class="col-12 col-sm-6 box__field">
                            <atram-textbox [parentFormGroup]="searchFormGroup"
                                            type="text"
                                            controlName="lastName"
                                            label="Last Name"
                                            [isError]="!searchFormGroup.get('lastName')?.valid && searchFormGroup.get('lastName')?.touched"
                                            placeholder="Last Name"
                                            [isRequired]="true">
                            </atram-textbox>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-sm-6 box__field">
                            <atram-textbox [parentFormGroup]="searchFormGroup"
                                            type="password"
                                            controlName="word"
                                            label="Nominate Password"
                                            [showEyeButton]="true"
                                            [isError]="(!searchFormGroup.get('word')?.valid && searchFormGroup.get('word')?.touched) || (searchFormGroup.get('word')?.value !== searchFormGroup.get('confirmWord')?.value)"
                                            placeholder="Nominate Password"
                                            [isRequired]="true">
                            </atram-textbox>
                            <h3 class="box__error-notif" *ngIf="(searchFormGroup.get('word')?.value !== searchFormGroup.get('confirmWord')?.value)">Your inputs did not match. Please try again.</h3>
                        </div>
                        <div class="col-12 col-sm-6 box__field">
                            <atram-textbox [parentFormGroup]="searchFormGroup"
                                            type="password"
                                            controlName="confirmWord"
                                            label="Confirm Password"
                                            [showEyeButton]="true"
                                            placeholder="Confirm Password"
                                            [isError]="(!searchFormGroup.get('confirmWord')?.valid && searchFormGroup.get('confirmWord')?.touched) || (searchFormGroup.get('word')?.value !== searchFormGroup.get('confirmWord')?.value)"
                                            [isRequired]="true">
                            </atram-textbox>
                            <h3 class="box__error-notif" *ngIf="(searchFormGroup.get('word')?.value !== searchFormGroup.get('confirmWord')?.value)">Your inputs did not match. Please try again.</h3>
                        </div>
                    </div>
                    <p class="box__instruction">*Your password should contain a minimum of 12 and maximum of 15 characters, 1 upper case, 1 lower case, 1 number, and 1 special character</p>
                    <div class="row">
                        <div class="d-sm-none col-12 offset-md-6 col-md-6">
                            <div class="buttons buttons--dual">
                                <div class="row">
                                    <div class="buttons__first col-12 col-sm-6">
                                        <atram-button label="Confirm"
                                            componentClass="btn-submit"
                                            (on-click)="proceed()">
                                        </atram-button>
                                    </div>
                                    <div class="col-12 col-sm-6">
                                        <atram-button buttonType="default"
                                            label="Sign In Instead"
                                            componentClass="btn-submit"
                                            (on-click)="goToSignIn()">
                                        </atram-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-none d-sm-block col-12 offset-md-6 col-md-6">
                            <div class="buttons buttons--dual">
                                <div class="row">
                                    <div class="buttons__first col-12 col-sm-6">
                                        <atram-button buttonType="default"
                                            label="Sign In Instead"
                                            componentClass="btn-submit"
                                            (on-click)="goToSignIn()">
                                        </atram-button>
                                    </div>
                                    <div class="col-12 col-sm-6">
                                        <atram-button label="Confirm"
                                            componentClass="btn-submit"
                                            (on-click)="proceed()">
                                        </atram-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<atram-modal #atramModal></atram-modal>
